import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import { formatFileType } from '../../../utils';

/**
 * Returns a formatter for Uppy restriction errors. Uppy lists the allowed
 * types verbatim ("application/pdf, image/*"); the formatter replaces them
 * with a localized list ("PDF or images"). Errors without allowed types pass
 * through unchanged.
 */
export function useFormatRestrictionError() {
  const { i18n, t } = useTranslation('ui');

  return useCallback(
    (error: Error, allowedFileTypes: string[] | undefined) => {
      if (!allowedFileTypes?.length) {
        return error.message;
      }

      const rawTypes = allowedFileTypes.join(', ');
      const friendlyTypes = new Intl.ListFormat(i18n.language, {
        type: 'disjunction',
        style: 'short',
      }).format(allowedFileTypes.map((type) => formatFileType(type, t)));

      return error.message.replace(rawTypes, friendlyTypes);
    },
    [i18n.language, t],
  );
}
